import { Stack } from "@mui/material";

import { useCurrentUser } from "Auth/Hooks/useCurrentUser";
import { AvailableFundsBar } from "Dashboard/Components/AvailableFundsBar";
import { ProjectTypeTiles } from "Dashboard/Components/ProjectTypeTiles";
import { RecentProjects } from "Dashboard/Components/RecentProjects";
import { SysAdminDashboard } from "Dashboard/Components/SysAdminDashboard";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const DashboardPage = (): React.ReactNode => {
  const { t } = useResource();

  const { user, isSysAdmin } = useCurrentUser();

  const firstName = user?.firstName ?? "";

  return (
    <AuthenticatedLayout
      title={t(Resources.Common.Dashboard)}
      subtitle={t(Resources.Common.GoodMorning, { name: firstName })}
    >
      {isSysAdmin ? (
        <SysAdminDashboard />
      ) : (
        <Stack spacing={Spacing.L}>
          <AvailableFundsBar />
          <ProjectTypeTiles />
          <RecentProjects />
        </Stack>
      )}
    </AuthenticatedLayout>
  );
};
